import axiosConfig from "./axiosConfig";

const EventService = {
  // Get all events
  getAllEvents: async () => {
    try {
      const response = await axiosConfig.get("/events");
      return response.data;
    } catch (error) {
      console.error("Error fetching events:", error);
      throw error;
    }
  },

  // Create a new event
  createEvent: async (eventData) => {
    try {
      const formData = new FormData();
      formData.append("title", eventData.title);
      formData.append("description", eventData.description);
      formData.append("dateDebut", eventData.dateDebut);
      formData.append("dateFin", eventData.dateFin);
      formData.append("location", eventData.location);

      if (eventData.photo) {
        formData.append("photo", eventData.photo);
      }

      const response = await axiosConfig.post("/events", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating event:", error);
      throw error;
    }
  },

  // Update an existing event
  updateEvent: async (id, eventData) => {
    try {
      const formData = new FormData();
      formData.append("title", eventData.title);
      formData.append("description", eventData.description);
      formData.append("dateDebut", eventData.dateDebut);
      formData.append("dateFin", eventData.dateFin);
      formData.append("location", eventData.location);

      if (eventData.photo) {
        formData.append("photo", eventData.photo);
      }

      const response = await axiosConfig.put(`/events/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating event with id ${id}:`, error);
      throw error;
    }
  },

  // Delete an event
  deleteEvent: async (id) => {
    try {
      const response = await axiosConfig.delete(`/events/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting event with id ${id}:`, error);
      throw error;
    }
  },

  // Get a single event by ID
  getEventById: async (id) => {
    try {
      const response = await axiosConfig.get(`/events/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching event with id ${id}:`, error);
      throw error;
    }
  },
};

export default EventService;
